<template>
  <q-option-group class="i-option-group" :inline="inline" :type="type" :options="filteredComputedOptions" :label="computedLabel" :value="computedValue"
    v-bind="$attrs" v-on="$listeners" />
</template>
<script>
import enums from '@/lib/enums'
import store from '@/store'
import _ from 'lodash'
import { StoreBisWordMixin, StoreBisDicMixin } from '@/lib/mixins'

export default {
  mixins: [StoreBisWordMixin, StoreBisDicMixin],
  props: {
    inline: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'radio',
      validator (val) {
        return ['radio', 'checkbox', 'toggle'].includes(val)
      }
    },
    options: Array,
    label: String,
    enum: String,
    word: String,
    dic: String,
    nullAsAll: Boolean,
    value: {
      require: true
    },
    blackList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    computedOptions () {
      if (this.options) {
        return this.options ?? []
      } else if (this.enum) {
        return enums[this.enum].items ?? []
      } else if (this.word) {
        return this.$$getWordsOptionsByType(this.word) ?? []
      } else if (this.dic) {
        return store.getters['bis/dic/modelsOptions'](this.dic) ?? []
      } else {
        return []
      }
    },
    filteredComputedOptions () {
      if (this.blackList.length) {
        return this.computedOptions.filter(i => {
          return !this.blackList.find(b => b === i.value)
        })
      } else {
        return this.computedOptions
      }
    },
    computedLabel () {
      if (this.label) {
        return this.label
      } else if (this.enum) {
        return enums[this.enum].label
      } else if (this.word) {
        return this.$$getWordLabelByType(this.word)
      } else if (this.dic) {
        return store.getters['bis/dic/modelLabel'](this.dic)
      } else {
        return null
      }
    },
    single () {
      return this.type === 'radio'
    },
    computedValue () {
      if (this.single) {
        return this.value
      }
      return this.nullAsAll && _.isNil(this.value) ? this.filteredComputedOptions.map(item => item.value) : (this.value ?? [])
    },
    valueNullAsAll () {
      return !this.single && this.nullAsAll && _.isNil(this.value)
    }
  },
  watch: {
    valueNullAsAll: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.$emit('input', this.computedValue)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.i-option-group {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
</style>
